import axios from 'axios';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import {loginToken} from '../../../helpers/LocalStorageHelper'
import { handleSuccess} from '../../../helpers/ErrorHelper'
import {clone} from '../../../helpers/DataHelper'
import {cancelPlanFormDispatch, planError, planFormServerValidationErrors, setDefaultPlanForm}
    from '../../../pages/site/plan/form/PlanForm-Action'
import store from '../../../Store';
import {scrollToError} from '../../../helpers/ScrollHelper'
import getSiteStatus from "../sites/site_status_get";
import getSite from "../sites/site_get"

function _success(success) {
    return {type: 'POST_PLAN_SUCCESS', success};
}

function _error(error) {
    return {type: 'POST_PLAN_ERROR', error};
}

function _processing(processing) {
    return {type: 'POST_PLAN_PROCESSING', processing};
}

function createPlan() {
    return (dispatch, getState) => {
        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));

        let {planForm, organizationDashboard, siteDashboard} = getState();
        let data = clone(planForm.data.payload);
        let organization_id = organizationDashboard.data.organization_id;
        let {site_id} = siteDashboard.data;

        axios({
            url: apiBaseUrl(`admin/organizations/${organization_id}/sites/${site_id}/plans`),
            method: "post",
            dataType: 'json',
            data,
            headers: {
                'Authorization': 'Bearer ' + loginToken()
            }
        })
            .then(function (res) {
                dispatch(_success(res));
                dispatch(_processing(false));
                handleSuccess(res)
                store.dispatch(cancelPlanFormDispatch())
                store.dispatch(setDefaultPlanForm())
                store.dispatch(getSite(site_id))
                store.dispatch(getSiteStatus(site_id));
            })
            .catch(function (error) {
                dispatch(_error(error));
                dispatch(_processing(false));
                // handleError( error )
                store.dispatch(planError(error.response.data.message))
                store.dispatch(cancelPlanFormDispatch())

                if (error.response && error.response.status === 422) {
                    store.dispatch(planFormServerValidationErrors(error.response.data.errors))
                    scrollToError();
                }
            });
    }
}


export default createPlan;